export function servicesActionStbActions(data, method) {
    return (dispatch) => Promise.resolve(
            dispatch({
                data,
                method,
                type: 'SERVICES_ACTION_UPDATE_STB_ACTIONS',
            })
        );
}
export function servicesActionPropertiesActions(data, method) {
    return (dispatch) => Promise.resolve(
            dispatch({
                data,
                method,
                type: 'SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS',
            })
        );
}
